import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import template from './sql-console-results.hbs'
import SqlConsoleModel from './sql-console-model'
import formatValue from 'scoreboard/components/format-value'
import ResultsView from 'scoreboard/reports/common/results-view'
import EmptyState from 'scoreboard/components/empty-state'
import invalidMessage from 'scoreboard/reports/common/invalid-message.hbs'
import runSqlTemplate from './run-sql.hbs'
import FormView from 'scoreboard/components/form-view'


function addSingleCellRow(content) {
	return '<tr><td>' + _.escape(content) + '</td></tr>'
}

function addRowsReturnedToHTML(tableBody) {
	if (tableBody.find('tr').length == 0) {
		tableBody.html(addSingleCellRow(i18n.get('admin.consoles.numberRowsReturned', 0)))
	}
}

var SqlConsole = ResultsView.extend({

	className: 'sql-console-result-view scroll-layout-xy table-hack-row display-pane-body form',


	/**
	 * @constructs
	 * @param options
	 */
	initialize: function(options) {
		ResultsView.prototype.initialize.apply(this, arguments)

		this.parent = this.options.parent
		if (this.parent) {
			this.parent.deferredReady = true
		}
		this.model = this.options.model || new SqlConsoleModel()
		/** @member {Chunker} */
		this.results = this.model.results
	},

	_template: function(ctx) {
		return template(ctx)
	},

	render: function() {
		delete this._keys
		this.$el.html(this._template(this.model.attributes))
		this.resultsDisplayed = this.$('.sql-results-container') //cache table container lookup
		this.tableBody = this.$('tbody')	//cache table body lookup
		this.tableHead = this.$('thead')	//cache table head lookup
		this.bannerError = this.$('.sql-banner-error')  //cache banner-error lookup

		var metadata = this.model.metadata
		if (metadata && metadata.error) {
			return this.renderError(metadata.error)
		}

		let query = this.model.get('query')
		if (_.isNil(query) || _.isEmpty(query)) {
			this.$el.html(new EmptyState({ body: invalidMessage({msgCode: 'report.sqlConsole.query.empty'}) })
				.render().remove('header').el)
			return this
		}

		if (!this.model.get('select') && !this.model.get('run')) {
			//#19780 make non select sql execution explicit by user action
			this.$el.html(new EmptyState({ body: runSqlTemplate({message: _.escape(query)}), noHeader: true }).render().el)
			this.formView = new FormView({
				el: this.el,
				allowCleanSubmission: true,
				submit: evt => {
					this.model.set('run', true, {silent: true})
					this.model.fetch().then(() => {
						this.render()
					})
				}
			}).start()
			return this
		}
		if (this.options.isReport) {
			this.$('.sql-results-container .panel-header').remove()
		}

		this.renderMaxResultsBanner({
			msgProperty: 'report.sqlConsole.query.warn.maxResults'
		})

		this.initializeScrollableTable(() => {
			addRowsReturnedToHTML(this.tableBody)
		})

		return this
	},

	_observeStream: function(stream) {
		this.results = stream
		if (this.results) {
			this.results.on('data', this.renderResults.bind(this))
			this.results.on('end', function() {
				addRowsReturnedToHTML(this.tableBody)
				if (this.parent) {
					this.parent.fullyLoaded = true
				}
			}.bind(this))
		}
	},

	renderTableHeader: function(data) {
		this.bannerError.empty()
		this.$el.removeClass('has-error')
		this.resultsDisplayed.removeClass('is-not-displayed')

		this.renderPanelHeader()

		if (data.length == 0) {
			return
		}

		this._keys = _.keys(data[0])

		var header = this.tableHead.find('th')
		_.each(this._keys, function(v) {
			header += '<th>'+_.escape(v)+'</th>'
		}.bind(this))
		this.tableHead.html('<tr>' + header + '</tr>')

		this._updateHeaderVisibility()
	},

	renderPanelHeader: function () {
		var title
		if (this.options.showLabel) {
			title = this.model.get('label')
		} else if (this.options.showQueryMetadata) {
			var metadata = this.model.metadata
			var queryResults = i18n.get('report.sqlconsole.queryResults')
			var queryMetadata = i18n.get('report.sqlconsole.queryResults.data',
				'<span class="results-total">' + _.escape(formatValue({ value: metadata.numResults || 0, shorten: false })) + '</span>', _.escape(metadata.duration))

			title = queryResults + '<span>' + queryMetadata + '</span>'
		}

		this.resultsDisplayed.find('h3').html(title)
		this.resultsDisplayed.find('.panel-header').toggleClass('is-not-displayed', !title)
	},

	renderResults: function(data) {
		if (!this._keys) {
			this.renderTableHeader(data)
		}

		var html = ''
		for (var i=0; i<data.length; i++) {
			var row = ''
			for (var j=0; j<this._keys.length; j++) {
				var column = this._keys[j]
				row += '<td>'+_.escape(data[i][column])+'</td>'
			}
			html += '<tr>'+row+'</tr>'
		}
		this.tableBody.append(html)
	},

	renderError: function(err) {
		this.resultsDisplayed.addClass('is-not-displayed')
		this.resultsDisplayed.find('h3').empty()
		this.bannerError.removeClass('is-not-displayed').html(err)
		this.$el.addClass('has-error')
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.scroller, this.formView], 'remove')
	},

	/**
	 * The presence of this function enables SendTo->Excel in the report header
	 */
	exportTable: function(label) {
		return this.model.fetchCSV()
	}
})

export default SqlConsole
export { template }

SqlConsole.__filename__ = 'components/sql-console/sql-console-results.js'
